import * as React from "react";

import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import { IconButton, Snackbar, Tooltip } from "@material-ui/core";

import { IButtonProps } from "./IButtonProps";

import { Analytics } from "Utility/Analytics";
import { IHttpRequest, Status, useHttp } from "Utility/useHttp";

export function FavoriteButton(props: IButtonProps): React.ReactElement | null {
    const [request, setRequest] = React.useState<IHttpRequest | null>(null);
    const [snackMessage, setSnackMessage] = React.useState<string | null>(null);

    const disabled = props.disabled ||
        props.quiltRenderData === null ||
        props.user === undefined ||
        request !== null;

    const onClick = () => {
        Analytics.favoriteQuilt(props.quiltRenderData!.code);

        setRequest({
            method: "post",
            url: `/api/favorites?quiltCode=${props.quiltRenderData!.code}`,
            user: props.user
        });
    };

    const state = useHttp(request);

    React.useEffect(() => {
        switch (state.status) {
            case Status.Complete:
                setSnackMessage("Saved quilt.");
                setRequest(null);
                break;
            case Status.Error:
                setSnackMessage("Failed to save quilt!");
                setRequest(null);
                break;
        }
    },
    [state]);

    if (props.user === undefined) {
        return null;
    }

    return (
        <>
            <Tooltip title="Save quilt">
                <span>
                    <IconButton size="small" color="primary" onClick={onClick} disabled={disabled}>
                        <BookmarkBorderIcon/>
                    </IconButton>
                </span>
            </Tooltip>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackMessage !== null}
                autoHideDuration={3000}
                onClose={() => setSnackMessage(null)}
                message={snackMessage}
            />
        </>
    )
}